import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { PriceImprovementExpirationTime } from 'state/quotes/priceEnhancements/priceImprovementRequest/priceImprovementRequest.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface PriceImprovementCreateRequest {
  quoteId: string;
  externalQuoteId?: string;
  requestedTradingOffer?: number;
  expirationTime: Nullable<PriceImprovementExpirationTime>;
  comment?: string;
}

export interface PriceImprovementRejectRequest {
  comment?: string;
}

export interface PriceImprovementsAcknowledgeRequest {
  improvements: PriceImprovementAcknowledgeRequest[];
}

interface PriceImprovementAcknowledgeRequest {
  requestForPriceImprovementId: string;
}

export interface PriceImprovementValidateRequest {
  comment?: string;
  priceAdjustment: number;
}

export interface PriceImprovementCreateResponse {
  requestForPriceImprovementId: string;
}

export interface PriceImprovementRejectResponse {}
export interface PriceImprovementValidateResponse {}

export interface PriceImprovementCancelResponse {}

export interface PriceImprovementAcknowledgeResponse {}

export function priceImprovementApi(http: IHttpClient) {
  return {
    create(request: PriceImprovementCreateRequest): Observable<PriceImprovementCreateResponse> {
      return http
        .postJSON<PriceImprovementCreateResponse>({
          url: `api/v1/price-improvements`,
          body: request,
          parseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    cancel(priceImprovementId: string): Observable<PriceImprovementCancelResponse> {
      return http
        .patch<PriceImprovementCancelResponse>({
          url: `api/v1/price-improvements/${priceImprovementId}/cancel`,
          parseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    reject(
      priceImprovementId: string,
      request: PriceImprovementRejectRequest,
    ): Observable<PriceImprovementRejectResponse> {
      return http
        .patch<PriceImprovementRejectResponse>({
          url: `api/v1/price-improvements/${priceImprovementId}/reject`,
          body: request,
          parseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    validate(
      priceImprovementId: string,
      request: PriceImprovementValidateRequest,
    ): Observable<PriceImprovementValidateResponse> {
      return http
        .patch<PriceImprovementRejectResponse>({
          url: `api/v1/price-improvements/${priceImprovementId}/validate`,
          body: request,
          parseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    acknowledge(request: PriceImprovementsAcknowledgeRequest): Observable<PriceImprovementAcknowledgeResponse> {
      return http
        .patch<PriceImprovementAcknowledgeResponse>({
          url: `api/v1/price-improvements/acknowledge`,
          body: request,
          parseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
